import React from "react";
import "./CircularAvatar.scss";
import { COLOR_CODES } from "../../../constant/colors";
type AppProps = {
  name?: string | undefined;
  image?: string | undefined | null;
  afterHeaderClassName?: string | undefined;
  style?: any;
};

const CustomizedAvatar = ({
  name,
  image,
  afterHeaderClassName,
  style,
}: AppProps) => {
  let finalName = "A";
  let lastName = "";
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;

  let blobSasUrl = `${blobBaseUrl}${image}?${blobToken}`;
  let isLastName = name && name?.split(" ").length > 1;

  if (name && name.length > 1) {
    finalName = name?.split(" ")[0].slice(0, 1).toUpperCase();
    if (isLastName) {
      lastName = name?.split(" ")[1].slice(0, 1).toUpperCase();
    }
  }

  const stringToHslColor = (str: string, s: number, l: number) => {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    var h = hash % 360;
    return "hsl(" + h + ", " + s + "%, " + l + "%)";
  };

  // let avatarBgColor = COLOR_CODES[Math.floor(Math.random() * COLOR_CODES.length)] || '#000';
  let avatarBgColor = stringToHslColor(
    name && name.length > 1 ? name : "anonymous",
    30,
    50
  );
  return (
    <div
      className={image?.length ? "" : "circularAvatarWrap size32"}
      style={{
        backgroundColor: image?.length ? "" : avatarBgColor,
        cursor: "pointer",
        width: style?.width,
        height: style?.width,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: style?.fontSize,
      }}
    >
      {image?.length ? (
        <img
          className={
            afterHeaderClassName && afterHeaderClassName?.length > 0
              ? `circularAvatarWrap ${afterHeaderClassName}`
              : "circularAvatarWrap size32 mb-1"
          }
          style={{
            backgroundColor: image?.length ? "" : avatarBgColor,
            cursor: "pointer",
            width: style?.width,
            height: style?.width,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: style?.fontSize,
          }}
          src={blobSasUrl}
          alt="profile pic"
        />
      ) : (
        `${finalName}${lastName}`
      )}
    </div>
  );
};

export default CustomizedAvatar;
